import React from 'react'

const GradesDefault  = () => {
  return (
    <div className="jumbotron">
      <h1>Grading module</h1>
      <p>Select a class on the left to start encoding grades.</p>
    </div>
  )
}

export default GradesDefault



// WEBPACK FOOTER //
// ./src/containers/Grades/default.js